import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { dictionaryBillingColumns } from '../constants/dictionary-billing-columns.constant';

export const generateBillingColumns = () => {
	return [
		{
			title: dictionaryBillingColumns[Enviroment.LANGUAGE].first_name,
			dataIndex: 'first_name',
			key: 'first_name',
			align:'center'

		},
		{
			title: dictionaryBillingColumns[Enviroment.LANGUAGE].last_name,
			dataIndex: 'last_name',
			key: 'last_name',
			align:'center'

		},
		{
			title: dictionaryBillingColumns[Enviroment.LANGUAGE].email,
			dataIndex: 'email',
			key: 'email',
			align:'center'

		},
		{
			title: dictionaryBillingColumns[Enviroment.LANGUAGE].phone,
			dataIndex: 'phone',
			key: 'phone',
			align:'center'

		},
		{
			title: dictionaryBillingColumns[Enviroment.LANGUAGE].sex,
			dataIndex: 'sex',
			key: 'sex',
			align:'center'

		},
		{
			title: dictionaryBillingColumns[Enviroment.LANGUAGE].rfc,
			dataIndex: 'rfc',
			key: 'rfc',
			align:'center'

		},
		{
			title: dictionaryBillingColumns[Enviroment.LANGUAGE].rut,
			dataIndex: 'rut',
			key: 'rut',
			align:'center'

		}
	
	];
};
